import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ITreePickerChildren } from './../../../../interfaces/tree-picker.interface';

export enum TreePickerSingleDirectionEnum {
  INPUT = 'input',
  OUTPUT = 'output'
};

export type TreePickerSingleDirectionType = TreePickerSingleDirectionEnum.INPUT | TreePickerSingleDirectionEnum.OUTPUT;

@Component({
  selector: 'siu-tree-picker-single',
  templateUrl: './tree-picker-single.component.html',
  styleUrls: [ './tree-picker-single.component.scss' ]
})
export class TreePickerSingleComponent implements OnInit {
  @Input() data: ITreePickerChildren;
  @Input() offsetText: number = 24;
  @Input() offsetTextIncrement: number = 20;
  @Input() initExpanded: boolean = false;
  @Input() direction: TreePickerSingleDirectionType;
  @Input() maxHeight: number;
  @Output('on-add') onAddEvent: EventEmitter<any> = new EventEmitter();
  @Output('on-remove') onRemoveEvent: EventEmitter<any> = new EventEmitter();
  @Input() readonly: boolean = false;
  @Input() sideDirection: 'ltr' | 'rtl' = 'ltr';
  @Input() hideParentButtons: boolean = false;

  style = null;
  constructor() { }

  ngOnInit() {
    if (this.maxHeight) {
      this.style = { 'max-height.px': this.maxHeight, 'overflow-y': 'auto' }
    }
  }

  HandleAdd = (e) => {
    this.onAddEvent.emit(e);
  }

  HandleRemove = (e) => {
    this.onRemoveEvent.emit(e);
  }

  get showNoFilterResultsFound(): boolean {
    return this.data && this.data.items && this.data.items.filter(x => x.$$node.visible !== false).length == 0;
  }

}
